import { CcLibrarySetModule } from "server/models"

export interface CcLibrarySetModuleState {
    data: CcLibrarySetModule
    showConfirmDelete: boolean
}

export const CC_LIBRARY_SET_MODULE_DATA = "CC_LIBRARY_SET_MODULE_DATA"
export const CC_LIBRARY_SET_MODULE_SHOW_CONFIRM = "CC_LIBRARY_SET_MODULE_SHOW_CONFIRM"
